import { soadT2Part1DataSchema } from "../../schemas/index.js";
export const soadT2Part1Template = {
    signing: {
        userOrTeamRequirement: {
            accreditation: [],
            teamType: ["soad"],
        },
    },
    formBuilderFields: [
        {
            type: "practitioner",
            field: "practitioner",
            label: "SOAD name and address",
            hideWarningBanners: true,
        },
        {
            type: "label",
            showStaticLabel: true,
            label: [
                "I am a registered medical practitioner appointed for the purposes of Part 4 of the Act (a SOAD).",
            ],
        },
        {
            type: "textbox",
            field: "treatment",
            label: "Enter description of treatment or plan of treatment. Indicate clearly if the certificate is only to apply to any or all of the treatment for a specific period.",
            rows: "5",
            copyFrom: {
                valueFn: (_data, context) => {
                    const part5 = context.previousPartsFormData.find((s) => s.section === "soadAuthorisation")?.data;
                    return [
                        part5?.planAuthorisedMedication,
                        part5?.timeLimitCertificateDuration,
                    ]
                        .filter(Boolean)
                        .join("\n\n");
                },
                label: "Copy from SRF Treatment plan",
            },
        },
        {
            type: "label",
            showStaticLabel: true,
            label: [
                "(a) I certify that this patient is capable of understanding the nature, purpose and likely effects of the above stated treatment or plan of treatment.",
            ],
        },
        {
            type: "label",
            showStaticLabel: true,
            label: [
                "(b) I certify that this patient has consented to that treatment.",
            ],
        },
    ],
    dataSchema: soadT2Part1DataSchema,
};
export const soadT2V1Base = {
    id: "mha-soad-t2",
    category: "soad",
    version: "1.0",
    status: "active",
    formName: "T2",
    section: "58(3)(a)",
    parts: [soadT2Part1Template],
    description: "Certificate of Consent to Treatment",
    extractGenericData: () => ({}),
};
//# sourceMappingURL=soad-t2.js.map